var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 .862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 11.327a5.7 5.7 0 0 1-5.716-5.664 5.716 5.716 0 0 1 11.432 0A5.7 5.7 0 0 1 8.2 11.327m0-9.867a4.2 4.2 0 1 0 4.245 4.2A4.229 4.229 0 0 0 8.2 1.46",
    transform: "translate(.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.324 17.3a.733.733 0 0 1-.732-.665 7.035 7.035 0 0 0-7-6.386h-.061a7.1 7.1 0 0 0-7.062 6.379A.736.736 0 0 1 0 16.5a8.636 8.636 0 0 1 8.6-7.707 8.5 8.5 0 0 1 8.451 7.717.73.73 0 0 1-.667.791.666.666 0 0 1-.067 0",
    transform: "translate(0 1.074)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypage);
export default __webpack_public_path__ + "static/media/mypage.9c005349483fc86317fbb5d78013ea70.svg";
export { ForwardRef as ReactComponent };